/**
 * wc-product-card — swatch click: swap image, image2, price, variant URL
 */

// Guard: chỉ đăng ký event listeners 1 lần dù script bị load nhiều lần
if (!window.wcCustomLoaded) {
window.wcCustomLoaded = true;

function wcSwatchActivate(btn) {
  const imgUrl      = btn.dataset.imgUrl;
  const img2Url     = btn.dataset.img2Url || '';
  const variantUrl  = btn.dataset.variantUrl;
  const price       = btn.dataset.price;
  const comparePrice = btn.dataset.comparePrice;

  // Dùng closest() thay vì getElementById để tránh lỗi duplicate ID
  // khi cùng product xuất hiện ở nhiều section (tabbed, featured, browsing...)
  const card = btn.closest('.wc-product-card');
  if (!card) return;

  // 1. Swap primary image
  // Phải reset srcset vì Shopify image_tag render widths: → tạo srcset
  // Trình duyệt ưu tiên srcset hơn src, nên phải xóa srcset trước khi set src mới
  const img = card.querySelector('.js-wc-card-img');
  if (img && imgUrl) {
    img.srcset = '';
    img.src = imgUrl;
  }

  // 2. Cập nhật secondary image (cũng reset srcset)
  const img2 = card.querySelector('.group-hover-img');
  if (img2) {
    if (img2Url) {
      img2.srcset = '';
      img2.src = img2Url;
      img2.style.display = '';
      if (img) img.classList.add('tw:group-hover:opacity-0');
    } else {
      img2.style.display = 'none';
      // Không có img2 → không fade img1 khi hover
      if (img) img.classList.remove('tw:group-hover:opacity-0');
    }
  }

  // 3. Update link href
  const link = card.querySelector('.wc-product-card__link');
  if (link && variantUrl) link.href = variantUrl;

  // 4. Cập nhật giá — tìm trong card thay vì getElementById
  const priceEl = card.querySelector('[id$="-price"]');
  if (priceEl && price) {
    const p = parseInt(price, 10);
    const cp = parseInt(comparePrice, 10);
    if (cp && cp > p) {
      priceEl.innerHTML =
        '<span style="color:#E02020">' + formatMoneyJP(p) + '</span> ' +
        '<span style="text-decoration:line-through;opacity:.5;font-size:10px">' + formatMoneyJP(cp) + '</span>';
    } else {
      priceEl.textContent = formatMoneyJP(p);
    }
  }

  // 5. Active border — toggle class, CSS stylesheet xử lý visual
  card.querySelectorAll('.js-wc-swatch').forEach(function (s) {
    s.classList.remove('js-wc-swatch--active');
  });
  btn.classList.add('js-wc-swatch--active');
}
window.wcSwatchActivate = wcSwatchActivate;

function formatMoneyJP(cents) {
  return '\u00a5' + Math.floor(cents / 100).toLocaleString('ja-JP');
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-wc-swatch');
  if (!btn) return;
  e.preventDefault();
  wcSwatchActivate(btn);
});

// Tooltip show/hide
document.addEventListener('mouseover', function (e) {
  const btn = e.target.closest('.js-wc-swatch');
  if (btn) {
    const tip = btn.parentElement && btn.parentElement.querySelector('.wc-swatch-tooltip');
    if (tip) tip.style.opacity = '1';
  }

  // Hover image swap cho JS-built cards
  const wrap = e.target.closest('.js-wc-img-wrap');
  if (wrap) {
    const primary   = wrap.querySelector('.js-wc-card-img');
    const secondary = wrap.querySelector('.group-hover-img');
    if (secondary && secondary.src && secondary.style.display !== 'none') {
      if (primary) primary.style.opacity = '0';
      secondary.style.opacity = '1';
    }
  }
});

document.addEventListener('mouseout', function (e) {
  const btn = e.target.closest('.js-wc-swatch');
  if (btn) {
    const tip = btn.parentElement && btn.parentElement.querySelector('.wc-swatch-tooltip');
    if (tip && !btn.parentElement.contains(e.relatedTarget)) tip.style.opacity = '0';
  }

  const wrap = e.target.closest('.js-wc-img-wrap');
  if (wrap && !wrap.contains(e.relatedTarget)) {
    const primary   = wrap.querySelector('.js-wc-card-img');
    const secondary = wrap.querySelector('.group-hover-img');
    if (primary)   primary.style.opacity = '1';
    if (secondary) secondary.style.opacity = '0';
  }
});

// Auto-init: activate first swatch của mỗi card khi trang load
function wcSwatchInitAll() {
  document.querySelectorAll('.js-wc-swatch--active').forEach(function (btn) {
    wcSwatchActivate(btn);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wcSwatchInitAll);
} else {
  // DOM đã sẵn sàng (script chạy sau DOMContentLoaded)
  wcSwatchInitAll();
}


/**
 * Browsing History — ghi product handle khi user xem product page.
 * Key: 'wc_browsing_history', lưu mảng handle, tối đa 20 items.
 */
(function () {
  var STORAGE_KEY = 'wc_browsing_history';
  var MAX_HISTORY = 20;

  // Theme này expose window.theme.pageType = 'product' trên product page
  var isProduct = (
    (typeof window.theme !== 'undefined' && window.theme.pageType === 'product')
    || location.pathname.indexOf('/products/') !== -1
  );

  if (!isProduct) return;

  // Lấy handle từ URL: /products/{handle}
  var match = location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match ? match[1] : '';

  if (!handle) return;

  try {
    var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (!Array.isArray(stored)) stored = [];

    // Xoá nếu đã tồn tại để đưa lên đầu
    stored = stored.filter(function (h) { return h !== handle; });
    stored.unshift(handle);

    // Giới hạn số lượng
    if (stored.length > MAX_HISTORY) stored = stored.slice(0, MAX_HISTORY);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch (e) {}
})();
  // Right-click / Mousedown protection
  (function() {
    document.addEventListener('mousedown', function(e){
      if(e.target.closest('[data-no-protect]')){
        e.stopImmediatePropagation();
      }
    }, true);
  })();

  /**
   * Tính toán chiều cao header và gán vào biến CSS --wc-header-height
   */
  function updateHeaderHeight() {
    const header = document.getElementById('wc-main-header');
    if (header) {
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
      document.documentElement.style.setProperty('--wc-header-height', height + 'px');
    }
  }

  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('load', updateHeaderHeight);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderHeight);
  } else {
    updateHeaderHeight();
  }

} // end !wcCustomLoaded
